import * as v from 'valibot';

export const marketplaceFieldSCSchema = v.object({
  id: v.string(),
  field: v.string(),
  marketplaceField: v.object({
    value: v.string(),
    name: v.string(),
    isActive: v.boolean(),
  }),
});
